import { FormControl, Input, ListItemText, MenuItem } from '@material-ui/core';
import React from 'react';
import Select from '@mui/material/Select';
import { makeStyles } from '@material-ui/styles';
import Theme from '../ui/Theme';

export const useStyles = makeStyles(() => ({
  textfield: (props) => ({
    backgroundColor: Theme.palette.secondary.main,
    height: props.height,
    width: props.width,
    marginBottom: props.marginBottom,
    padding: '12px 12px 12px 12px',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '21px',
    marginTop: '12px',
  }),
}));

const PopupDropDown = (props) => {
  const styleProps = {
    width: props.width,
    height: props.height,
    marginBottom: props.marginBottom,
  };
  const classes = useStyles(styleProps);
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const dropdownListItems = () => {
    const items = [];
    props.list?.forEach((option) => {
      items.push(
        <MenuItem key={`${option.id}-${option.title || option.name}`} name={option.id} value={option.title ? option.title : option.name}>
          <ListItemText primary={option.title ? option.title : option.name} />
        </MenuItem>,
      );
    });
    return items;
  };
  return (
    <FormControl>
      <Select
        name={props.name}
        labelId="demo-multiple-checkbox-label"
        id="demo-multiple-checkbox"
        value={props.value || 'Select a value'}
        onChange={props.handleChange}
        input={<Input disableUnderline className={classes.textfield} />}
        renderValue={(selected) => selected}
        MenuProps={MenuProps}
      >
        {dropdownListItems()}
      </Select>
    </FormControl>
  );
};

export default PopupDropDown;
